import { FunctionComponent } from "react";

const NAV: FunctionComponent = () => {
  return (
    <div className="still self-stretch flex flex-row items-center justify-between text-left text-[1.5rem] text-white font-nunito">
      <img
        className="abs relative w-[3.75rem] h-[3.79rem] object-cover"
        alt=""
        src="/nav@2x.png"
      />
      <a className="cursor-pointer text-darkgray no-underline ml-6 flex-1 rounded-7xl bg-gray-100 box-border h-[4.06rem] flex flex-col items-center justify-center min-w-[9.38rem] max-w-[18.75rem] border-[2px] border-solid border-white" href={"https://www.unityacademy.io/courses/trading-introduction"} target="_blank">
        <div>
          <div className="relative color-white font-semibold">Back to Home</div>
        </div>
      </a>
    </div>
  );
};

export default NAV;
